import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import {
    addDoc,
    collection,
    doc,
    getDoc,
    onSnapshot,
    orderBy,
    query,
    updateDoc,
    where
} from 'firebase/firestore';
import { auth, db } from '../../firebase';
import "../../App.css";
import Menu from '../../panel/Menu';
import moment from 'moment';

function Roomcleanings() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });

    const [cleanrooms, setcleanrooms] = useState([]);
    const [username, setusername] = useState();
    const [userData, setUserData] = useState();
    const [loadincount, setloadincount] = useState(true);
    const [searchText, setsearchText] = useState("");

    // Pagination
    const [page, setPage] = useState(1);
    const rowsPerPage = 10;

    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fethUsers()
        });
    });

    const fethUsers = async () => {
        try {
            if (userData) {
                if (loadincount) {
                    const docRef = doc(db, "users", userData.uid)
                    const docSnap = await getDoc(docRef)
                    if (docSnap.exists()) {
                        setusername(docSnap.data().username);
                        setloadincount(false)
                    }
                }
            }
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        if (searchText === '') {
            fetchData1()
        } else {
            fetchData2()
        }
    }, [searchText]);

    const fetchData1 = async () => {
        try {
            const q = query(
                collection(db, 'cleaningrooms'),
                orderBy("createdAt", "desc"),
                where('status', '==', 'Cleaning')
            );
            onSnapshot(q, (querySnapshot) => {
                const allData = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data()
                }));

                // ✅ Keep only unique roomnames
                const uniqueRooms = Array.from(
                    new Map(allData.map(item => [item.data.roomname, item])).values()
                );

                setcleanrooms(uniqueRooms);
            });
        } catch (error) {
            Toast.fire({
                icon: "error",
                title: error.message
            });
        }
    }


    const fetchData2 = async () => {
        try {
            const filteredData = cleanrooms.filter((item) => {
                const room = String(item.data.roomname || "").toUpperCase();
                return room.includes(searchText.toUpperCase());
            });

            // ✅ Ensure unique rooms in filtered data
            const uniqueFiltered = Array.from(
                new Map(filteredData.map(item => [item.data.roomname, item])).values()
            );

            setcleanrooms(uniqueFiltered);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }


    const roomCleaned = async (itemid, roomid) => {
        try {
            await updateDoc(doc(db, "cleaningrooms", itemid), {
                status: "Cleaned",
                cleanedby: username,
                cleanedtime: moment().format('DD/MM/YYYY HH:mm:ss A'),
            });

            await updateDoc(doc(db, "roomdetails", roomid), {
                status: "Available",
            })

            Toast.fire({ icon: "success", title: 'Room Successfully Cleaned' });
            fetchData1();

        } catch (error) {
            console.log(error.message);
        }
    }

    // Pagination logic
    const indexOfLast = page * rowsPerPage;
    const indexOfFirst = indexOfLast - rowsPerPage;
    const currentRooms = cleanrooms.slice(indexOfFirst, indexOfLast);
    const totalPages = Math.ceil(cleanrooms.length / rowsPerPage);

    return (
        <div>
            <Menu />
            <div className="content-wrapper" style={{ backgroundColor: '#f9fafc' }}>
                <section className="content">
                    <div className="container-fluid">
                        <button className="btn btn-primary mb-3" style={{ textTransform: "uppercase", fontWeight: 'bold' }}>
                            || Cleaning Rooms ||
                        </button>

                        <div className="card shadow-lg border-0">
                            <div className="p-3 d-flex justify-content-between align-items-center">
                                <input
                                    type="search"
                                    value={searchText}
                                    onChange={(e) => setsearchText(e.target.value)}
                                    className='form-control col-sm-4'
                                    placeholder='🔍 Search by Room No...'
                                    style={{ maxWidth: "300px" }}
                                />
                            </div>

                            <div className="card-body table-responsive p-0">
                                <table className="table table-bordered table-hover table-striped text-center">
                                    <thead className="table-primary">
                                        <tr>
                                            <th>Sr No</th>
                                            <th>Room No</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentRooms.length > 0 ? (
                                            currentRooms.map((item, index) =>
                                                <tr key={item.id}>
                                                    <td>{indexOfFirst + index + 1}</td>
                                                    <td className='fw-bold text-primary'>{item.data.roomname}</td>
                                                    <td>
                                                        <button
                                                            onClick={() => {
                                                                if (window.confirm('Are you sure to mark this room as cleaned?')) {
                                                                    roomCleaned(item.id, item.data.roomid)
                                                                }
                                                            }}
                                                            className='btn btn-success btn-sm'
                                                        >
                                                            <i className="fa fa-check"></i> Cleaning Done
                                                        </button>
                                                    </td>
                                                </tr>
                                            )
                                        ) : (
                                            <tr>
                                                <td colSpan="3" className="text-muted">No cleaning rooms found</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {/* Pagination */}
                            {cleanrooms.length > rowsPerPage && (
                                <div className="d-flex justify-content-between align-items-center p-3">
                                    <span>Page {page} of {totalPages}</span>
                                    <div>
                                        <button
                                            className="btn btn-outline-secondary btn-sm me-2"
                                            disabled={page === 1}
                                            onClick={() => setPage(page - 1)}
                                        >
                                            ◀ Prev
                                        </button>
                                        <button
                                            className="btn btn-outline-secondary btn-sm"
                                            disabled={page === totalPages}
                                            onClick={() => setPage(page + 1)}
                                        >
                                            Next ▶
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </section>
            </div>
        </div>
    )
}

export default Roomcleanings
